import { render } from "./autocall.vue?vue&type=template&id=22c5b9b1&scoped=true&ts=true"
import script from "./autocall.vue?vue&type=script&lang=ts"
export * from "./autocall.vue?vue&type=script&lang=ts"

import "./autocall.vue?vue&type=style&index=0&id=22c5b9b1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c5b9b1"]])

export default __exports__